import "@hotwired/turbo-rails"
import "./channels/admin_orders_channel"
import "./channels/public_order_tracking_channel"
import { Application } from "@hotwired/stimulus"
import SidebarController from "./controllers/sidebar_controller"
import CategorySelectController from "./controllers/category_select_controller"
import AutoSubmitController from "./controllers/auto_submit_controller"
import CartSidebarController from "./controllers/cart_sidebar_controller"
import DeliveryWindowsCalendarController from "./controllers/delivery_windows_calendar_controller"

window.Stimulus = Application.start()
window.Stimulus.register("sidebar", SidebarController)
window.Stimulus.register("category-select", CategorySelectController)
window.Stimulus.register("auto-submit", AutoSubmitController)
window.Stimulus.register("cart-sidebar", CartSidebarController)
window.Stimulus.register("delivery-windows-calendar", DeliveryWindowsCalendarController)
